import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { getValidity, formatValidityMonth, mountValidityDateRange } from '../../_helpers/pdfHelpers'

const ActionPlanSection = ({ serviceOrder }) => {
  const validityMonth = useMemo(() => {
    const date = getValidity(serviceOrder)
    return formatValidityMonth(date)
  }, [serviceOrder])

  const dateValidity = useMemo(() => {
    return mountValidityDateRange(serviceOrder)
  }, [serviceOrder])

  return (
    <View id="16">
      <Text bold size="small">
        16. ESTABELECIMENTO DE PLANO DE AÇÃO COM METAS, PRIORIDADES E CRONOGRAMA
      </Text>

      <Separator weight={4} />

      <Text>
        De acordo com o levantamento de campo, será elaborado um plano de ação contemplando atividades, metas e
        prioridades a serem implementadas de forma a adequar as condições ergonômicas conforme determina a NR-17.
        <br />O Plano deverá incluir todas as atividades identificadas na vistoria ou definidas como medidas de
        controle. Os responsáveis e prazos de cada atividade deverão ser definidos em consenso com o responsável pelo
        estabelecimento ou posto de trabalho. Após os levantamentos e conclusões, devem ser relacionadas no cronograma
        em anexo, as metas estabelecidas, bem como o planejamento para o cumprimento destas metas.
      </Text>

      <Separator weight={4} />

      <Table width="100%">
        <TableRow>
          <TableHeadText colSpan={15} align="center">
            {`Cronograma ${dateValidity.currentYear} a ${dateValidity.expiryYear}`}
          </TableHeadText>
        </TableRow>
        <TableRow>
          <TableHeadText align="center" rowSpan={2}>
            #
          </TableHeadText>
          <TableHeadText align="center" rowSpan={2}>
            Planejamento Anual de Ações do AET
          </TableHeadText>
          <TableHeadText align="center" rowSpan={2}>
            Responsável
          </TableHeadText>
          <TableHeadText align="center" colSpan={12}>
            Meses
          </TableHeadText>
        </TableRow>
        <TableRow>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableHeadText key={month} align="center">
              {month}º
            </TableHeadText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">1</TableColText>
          <TableColText>Levantamento das informações Para análise ergonômica</TableColText>
          <TableColText>SESMT Santander</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === 1 ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">2</TableColText>
          <TableColText>Elaboração do relatório da Análise ergonômica</TableColText>
          <TableColText>Responsável técnico da vistoria</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === 1 ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">3</TableColText>
          <TableColText>Apresentação dos resultados</TableColText>
          <TableColText>Responsável técnico da vistoria</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === 12 ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">4</TableColText>
          <TableColText>Planejamento de ações</TableColText>
          <TableColText>Responsável pela Agência/ Programa</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              X
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">5</TableColText>
          <TableColText>Acompanhamento do plano de ações</TableColText>
          <TableColText>SESMT Santander</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              X
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">6</TableColText>
          <TableColText>Avaliação crítica das ações</TableColText>
          <TableColText>SESMT Santander</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === 3 ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">7</TableColText>
          <TableColText>Revisão da análise ergonômica</TableColText>
          <TableColText>Responsável pela Agência/ Programa</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === 12 ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>

        <TableRow>
          <TableColText align="center">8</TableColText>
          <TableColText>Aprofundar os riscos antecipados no PGR</TableColText>
          <TableColText>Responsável técnico da vistoria</TableColText>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
            <TableColText key={month} align="center">
              {month === validityMonth ? 'X' : ''}
            </TableColText>
          ))}
        </TableRow>
      </Table>

      <Separator weight={8} />
    </View>
  )
}

export default ActionPlanSection
